import { dateFromString } from '../../components/Filter/masks'
import {
  convertDecimalCurrency,
  convertDecimalPercentage
} from '../../utils/utils'

const csvDataBuilder = (arr) => {
  let res = [
    [
      'Pedido',
      'Data',
      'Cliente',
      'Valor Pedido',
      'Valor Produtos',
      'Comissão',
      'Gimplus'
    ]
  ]
  arr?.forEach((element) => {
    res.push(objectToCSVArray(element))
  })
  return res
}

const objectToCSVArray = (data) => {
  let res = []
  res[0] = data.pedidoId
  res[1] = dateFromString(data.DataPedido)
  res[2] = data.NomeCliente
  res[3] = convertDecimalCurrency(data.ValorPedidoTotal)
  res[4] = convertDecimalCurrency(data.ValorTotalProdutos)
  res[5] = convertDecimalPercentage(data.PercentualCommissao) + '%'
  res[6] = convertDecimalCurrency(data.TotalComissao)
  return res
}

export default csvDataBuilder
